import React, { useEffect } from 'react';
import { useMoldOrders } from '../hooks/useMoldOrders';
import MainContainer from '../components/layout/MainContainer';
// import KanbanBoard from '../components/KanbanBoard';
import BoardSkeleton from '../components/KanbanBoard/BoardSkeleton';
import ErrorPage from '../components/pages/Error';
import { usePreferences } from '../context/PreferencesContext';
import { useLocation } from 'react-router-dom';
import NewKanbanBoard from '@/components/KanbanBoard/NewKanbanBoard';

interface KanbanBoardContainerProps {
  boardType?: string;
  displayMode?: 'tv' | 'default';
}

const KanbanBoardContainer: React.FC<KanbanBoardContainerProps> = ({
  boardType: propsBoardType = 'maintenance',
  displayMode = 'default',
}) => {
  const { moldOrders, loading, error, fetchMoldOrdersForKanban } = useMoldOrders();
  const { preferences } = usePreferences();
  const location = useLocation();

  // Get boardType from URL parameters, validate it, or fall back to the props value or default
  const getBoardTypeFromUrl = (): string => {
    // For TV display mode, prioritize props over preferences
    if (displayMode === 'tv' && propsBoardType) {
      return propsBoardType;
    }
    const params = new URLSearchParams(location.search);
    const urlBoardType = params.get('boardType');
    // Check if the URL parameter is a valid MoldOrderFirstLevelType
    // if (urlBoardType && ['repair', 'maintenance', 'mold_acceptance'].includes(urlBoardType)) {
    if (urlBoardType) {
      return urlBoardType;
    }
    // Use preferences.kanbanBoardType if available, else propsBoardType
    if (preferences?.kanbanBoardType) {
      return preferences.kanbanBoardType;
    }
    return propsBoardType;
  };

  const boardType = getBoardTypeFromUrl();

  useEffect(() => {
    fetchMoldOrdersForKanban();
  }, [boardType, fetchMoldOrdersForKanban]);

  if (loading) {
    if (displayMode === 'tv') {
      return (
        <BoardSkeleton />
      );
    }

    return (
      <MainContainer>
        <BoardSkeleton />
      </MainContainer>
    );
  }
  if (error) return <ErrorPage />;

  // return (
  //   <KanbanBoard
  //     moldOrders={moldOrders}
  //     preferences={preferences}
  //     boardType={boardType}
  //     displayMode={displayMode}
  //   />
  // );
  return (
    <NewKanbanBoard
      moldOrders={moldOrders}
      preferences={preferences}
      boardType={boardType}
      displayMode={displayMode}
    />
  );
};

export default KanbanBoardContainer;
